import { useTheme } from '@mui/material/styles'
import Typography from '@mui/material/Typography'
import { ColdCard } from '@repo/shared-core-ui-components/ColdCard'
import { ImageGlowWrapper } from '@repo/shared-core-ui-components/StyleHelpers/ImageGlowWrapper'
import Iconify from '@repo/shared-core-ui-components/Iconify/iconify'
import { useResponsive } from '@repo/shared-theme-utils/hooks/useResponsive'
import Image from 'next/image'
import StrategyTestResultsImage from '../../../../public/assets/strategy-editor/strategy-test-results.png'

export function TemplateColdCard() {
  const theme = useTheme()
  const lgUp = useResponsive('up', 'lg')

  return (
    <ColdCard
      variant={'half'}
      leftContent={
        <>
          <Typography variant={'h2'}>Save your configs as a Template</Typography>

          <Typography variant={'h6'} color="textSecondary" sx={{ marginBottom: 3 }}>
            Easily swap and load your tradingbot configuration by using templates.
          </Typography>
          <ul style={{ textAlign: 'start', listStyle: 'none' }}>
            <li style={{ display: 'flex' }}>
              <Iconify icon={'ic:baseline-check'} sx={{ marginRight: 1 }} />
              <Typography variant={'h6'}>Detailed reports on your strategy's performance</Typography>
            </li>
            <li style={{ display: 'flex' }}>
              <Iconify icon={'ic:baseline-check'} sx={{ marginRight: 1 }} />
              <Typography variant={'h6'}>Fully customizable strategy editor</Typography>
            </li>
            <li style={{ display: 'flex' }}>
              <Iconify icon={'ic:baseline-check'} sx={{ marginRight: 1 }} />
              <Typography variant={'h6'}>Simulated Order and Position </Typography>
            </li>
            <li style={{ display: 'flex' }}>
              <Iconify icon={'ic:baseline-check'} sx={{ marginRight: 1 }} />
              <Typography variant={'h6'}>Sharable strategy performance reports with other users</Typography>
            </li>
          </ul>
        </>
      }
      rightContent={
        <ImageGlowWrapper>
          <Image
            alt="dashboard"
            src={StrategyTestResultsImage}
            quality={75}
            style={{
              borderRadius: 'inherit',
              margin: 0,
              height: 'auto',
              width: lgUp ? 'unset' : '100%'
            }}
          />
        </ImageGlowWrapper>
      }
    />
  )
}
